

export default function Left({ animals, setAnimals, order }) {
    //Galim būtų išsikelti darant pusės patikrinimą
    const changeSide = animal => {
        let animalCng = animals.find((an) => an.id === animal.id)
        animalCng.side = 'Right';
        animalCng.message = 'msgDisplay'
        setAnimals(a => a.filter((el) => el.id !== animal.id))
        setAnimals(a => [...a, animalCng]);
        setTimeout(_ => {
            setAnimals(a => a.map((an) => an.id === animal.id ? { ...an, message: 'msgNoDisplay' } : an));
        }, 2000)
    }


    return (
        <>

            <div className='left-field'>
                {animals.map(animal => animal.side === 'Left' ?
                    <div key={animal.id} className={animal.type} onClick={_ => changeSide(animal)}>{animal.id}
                        <div className={animal.message}>{animal.type === 'cow' ? 'mooo!' : 'baaa!'}</div></div> : '')}
            </div>

        </>

    )
}